import { apiUrl } from '@/constants';
import axios from 'axios';

const state = {
    clients : [],
    message : ''
}

const mutations = {
    SET_CLIENTS(state, clients){
        state.clients = clients;
    },
    MESSAGE(state, message){
      state.message = message;
    }
};

const actions = {
    async addClient({commit}, client){
      try {
        const response = await axios.post(`${apiUrl}/clients`, client, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        commit('MESSAGE', response.data);
      } catch (error) {
        console.error('Error fetching clients:', error);
         this.$store.dispatch('errors/raiseError', error.message || 'An unexpected error occurred.');
      }
    },
    async updateClient({commit}, client){
      try {
        const response = await axios.patch(`${apiUrl}/clients/${client.id}`, client , {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        commit('MESSAGE', response.data);
        } catch (error) {
          console.error(error);
           this.$store.dispatch('errors/raiseError', error.message || 'An unexpected error occurred.');
        }
    },
    async fetchClients({ commit }) {
        try {
          const response = await axios.get(`${apiUrl}/clients`, {
            headers: {
              'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
          commit('SET_CLIENTS', response.data);
        } catch (error) {
          console.error('Error fetching clients:', error);
        }
      },
  
};

const getters = {
 
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
